const nameToUrls = {
  users: "api/users/",
  settings: "api/config/",
};
export default nameToUrls;
